export default {
      id: "missed-call-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#missed-call-usage",
      toString: function () {
        return this.url;
      }
    }